//import "preact/debug";

import { NasFormComponent } from 'shared/nas-form';
import { ServiceEditorService } from 'project/services';

// Note : this is not a React Component - it creates them
export default class CancelServiceListingRequestForm extends NasFormComponent {

    steps = null;

    static getNamespace() {
        return 'cancel-service-listing-request-form';
    }

    static getRequiredRefs() {
        return ['main_details_placeholder'];
    }

    onInit() {
        this.editMode = false;
        this.renderForm(this.editMode);
    }

    createWizardSteps = () => {

        var steps = [];

        var step = {
            name: "Cancel change", properties:
                [
                    {
                        name: "serviceListingRequestGuid",
                        displayName: "serviceListingRequestGuid",
                        inputType: "HiddenInput",
                    },
                    {
                        name: "serviceName",
                        displayName: "Service name",
                        inputType: "TextInput",
                        allowEdit: false,
                    },
                    {
                        name: "description",
                        displayName: "Description",
                        inputType: "TextInput",
                        allowEdit: false,
                    },
                    {
                        name: "cancellationReason",
                        displayName: "Reason",
                        inputType: "TextInput",
                    },
                ]
        };
        step.formFields = this.onCreateFormFields(undefined, step.properties, this.dataObjectInstance);

        step.formFields.serviceListingRequestGuid.value = this.options.serviceListingRequestGuid;
        step.formFields.serviceName.value = this.options.serviceName;
        step.formFields.description.value = this.options.description;

        //  add the step to the form
        steps.push(step);

        return steps;
    }

  
}
